<template>
    <div class="receipt-container">
        <div v-if="data.order_type === 'bulky'" class="bulky-order">
            <div v-if="data.shipping && data.shipping.receipt_number" class="receipt-info">
                <div class="receipt-number cursor-pointer" @click="copyReceiptNumber" v-tooltip="`Klik untuk Menyalin Nomor Resi Pengiriman`">
                    <small class="font-weight-bold">
                        {{ data.shipping.receipt_number }}
                    </small>
                    <small class="bi bi-clipboard-check cursor-pointer"></small>
                </div>
            </div>
            <hr v-if="data.shipping && data.shipping.receipt_number && data.shipping.cancelled_receipt_number" />
            <div v-if="data.shipping && data.shipping.cancelled_receipt_number" class="cancelled-info">
                <span class="cancelled-label">Cancelled:</span>
                <span class="cancelled-number">{{ data.shipping.cancelled_receipt_number }}</span>
            </div>
            <!-- <div v-else class="no-receipt">-</div> -->
        </div>
        <div v-else>
            <a class="btn btn-sm btn-primary btn-nowrap d-flex align-content-end justify-content-center" target="__blank" :href="data.shipping.label">
                <i class="bi bi-download text-sm" style="font-size: 12px;"></i>
                <small class="font-weight-bold">Download</small>
            </a>
        </div>
    </div>
</template>

<script>
export default {
	name: 'ReceiptNumberColumn',
	props: {
		data: {
			type: Object,
			default: () => ({}),
		},
	},
	methods: {
		copyReceiptNumber() {
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Receipt Number Salin',
				text: 'Berhasi Menyalin Resi',
			});

			navigator.clipboard.writeText(this.data.shipping?.receipt_number);
		},
	},
};
</script>

<style scoped lang="scss">
.receipt-container {
    border-radius: 5px;
}

.bulky-order {
    margin-bottom: 10px;
}

.receipt-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.receipt-number {
    font-size: 1.2em;
    color: #333;
}

.copy-board {
    color: #007bff;
    opacity: 0.8;
    transition: opacity 0.2s;

    &:hover {
        opacity: 1;
    }
}

.cancelled-info {
    margin-top: 10px;
    color: #ff6666;
}

.cancelled-label {
    font-weight: bold;
}

.cancelled-number {
    display: block;
    color: #333;
}

.no-receipt {
    color: #888;
    font-style: italic;
}
</style>
